import {
  addToCart,
  removeFromCart,
  clearCart,
  loadCart,
  applyPromoCode,
} from "./asyncThunks";

// Helper function to save cart to localStorage
const saveToLocalStorage = (items) => {
  try {
    localStorage.setItem("cart", JSON.stringify(items));
  } catch (error) {
    console.error("Error saving cart to localStorage:", error);
  }
};

// Helper function to calculate totals
const calculateTotals = (items) => {
  const totalItems = items.length;
  const totalAmount = items.reduce(
    (sum, item) => sum + Number(item.price),
    0
  );
  return { totalItems, totalAmount };
};

export const loadCartBuilder = (builder) => {
  builder
    .addCase(loadCart.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(loadCart.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.items = payload;
      const totals = calculateTotals(payload);
      state.totalItems = totals.totalItems;
      state.totalAmount = totals.totalAmount;
    })
    .addCase(loadCart.rejected, (state, { error }) => {
      state.loading = false;
      state.error = error.message;
      state.items = [];
      state.totalItems = 0;
      state.totalAmount = 0;
    });
};

export const addToCartBuilder = (builder) => {
  builder
    .addCase(addToCart.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(addToCart.fulfilled, (state, { payload }) => {
      state.loading = false;

      // Only add if payload is not null (course wasn't already in cart)
      if (payload) {
        state.items.push(payload);

        // Recalculate totals
        const totals = calculateTotals(state.items);
        state.totalItems = totals.totalItems;
        state.totalAmount = totals.totalAmount;

        // Save to localStorage
        saveToLocalStorage(state.items);
      }
    })
    .addCase(addToCart.rejected, (state, { error }) => {
      state.loading = false;
      state.error = error.message;
    });
};

export const removeFromCartBuilder = (builder) => {
  builder
    .addCase(removeFromCart.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(removeFromCart.fulfilled, (state, { payload: courseId }) => {
      state.loading = false;
      state.items = state.items.filter((item) => item.courseId !== courseId);

      // Recalculate totals
      const totals = calculateTotals(state.items);
      state.totalItems = totals.totalItems;
      state.totalAmount = totals.totalAmount;

      // Save to localStorage
      saveToLocalStorage(state.items);
    })
    .addCase(removeFromCart.rejected, (state, { error }) => {
      state.loading = false;
      state.error = error.message;
    });
};


export const clearCartBuilder = (builder) => {
  builder
    .addCase(clearCart.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(clearCart.fulfilled, (state) => {
      state.loading = false;
      state.items = [];
      state.totalItems = 0;
      state.totalAmount = 0;
      state.appliedPromo = null;

      // Clear localStorage
      saveToLocalStorage([]);
    })
    .addCase(clearCart.rejected, (state, { error }) => {
      state.loading = false;
      state.error = error.message;
    });
};

export const applyPromoBuilder = (builder) => {
  builder
    .addCase(applyPromoCode.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(applyPromoCode.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.appliedPromo = payload;
    })
    .addCase(applyPromoCode.rejected, (state, { error }) => {
      state.loading = false;
      state.error = error.message;
    });
};
